import Vue from 'vue';
import { DataService } from '../../data.service';
import { landcoverClasses as legend } from '../../../config/chart-legends';

const chartID = 'getCountyAgricultureChange';
/**
 * Tab 5: Agriculture: Net Distribution Of Agriculture Change By Agriculture Type
 * getCountyAgricultureChange
 */
export class Tab5Chart3 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    updateChartData(response) {
        let gain = [], loss = [];
        response.data.change.forEach((c, i) => {
            if (c < 0) {
                gain.push(0);
                loss.push(c);
            } else {
                gain.push(c);
                loss.push(0);
            }
        });
        this.chart.chartOptions.series[0].data = gain;
        this.chart.chartOptions.series[1].data = loss;
        this.chart.chartOptions.xAxis.categories = response.data.categoryAbbr;        
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Net Distribution Of Agriculture Change By Agriculture Type',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptions: {
                        chart: {
                            type: 'bar',
                            marginTop: 40
                        },
                        plotOptions: {
                            series: {
                                stacking: 'normal'
                            }
                        },
                        colors: ['#804000', '#b28c66'],
                        xAxis: {
                            title: {
                                text: 'Agriculture Classes'
                            },
                            categories: ["CRP", "PAS"],
                        },
                        yAxis: {
                            title: {
                                text: 'Square Miles'
                            }
                        },
                        tooltip: {
							shared: true,
                            formatter: function () {
								let tooltip = '';
								for(let i=0; i < this.points.length; i++) {
									if(i != 0) {
										tooltip += '<br>-------<br>'
									}
									tooltip += '<b>' + this.points[i].series.name + '</b><br>' + legend[this.x].name + '<br><b>' + this.points[i].y + '</b> square miles';
								}
								return tooltip;
                            }
                        },
                        series: [
                            {
                                name: 'Gain',
                                data:
                                    [
                                        4.39, 7.81
                                    ]
                            },
                            {
                                name: 'Loss',
                                data:
                                    [
                                        -3.50, -3.32
                                    ]
                            }
                        ]
                    }
                }
            }
        });
        //end vue component
    }
}
